/**
 * RoleBadge — small colored pill for a platform user role. Extracted from
 * `routes/admin/users/index.tsx` (issue #1411).
 */
export function RoleBadge({ role }: { role: string }): JSX.Element {
  const cls = `users-role-badge users-role-badge--${role.toLowerCase().replace(/[^a-z]/g, '-')}`;
  return <span className={cls}>{role}</span>;
}
